import _classCallCheck from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var InfernoEffect = /*#__PURE__*/function () {
  function InfernoEffect(effect, dependency) {
    _classCallCheck(this, InfernoEffect);

    this.effect = effect;
    this.dependency = dependency;
    this.destroy = effect();
  }

  _createClass(InfernoEffect, [{
    key: "update",
    value: function update(dependency) {
      var currentDependency = this.dependency;

      if (dependency) {
        this.dependency = dependency;
      }

      if (!dependency || dependency.some(function (d, i) {
        return currentDependency[i] !== d;
      })) {
        this.dispose();
        this.destroy = this.effect();
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.destroy) {
        this.destroy();
      }
    }
  }]);

  return InfernoEffect;
}();